/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Reviewed_AtInputs */



/**
* | output |
* | --- |
* | "Reviewed At" |
*
* @param {Audit_Details_Reviewed_AtInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_reviewed_at = /** @type {((inputs?: Audit_Details_Reviewed_AtInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Reviewed_AtInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Überprüft am")
	return /** @type {LocalizedString} */ ("Reviewed At")
});